import { DI } from '@microsoft/fast-foundation';
import Analytics from 'analytics';
import { logger } from '../utils';
/**
 * Analytics event types
 * @public
 */
export var FoundationAnalyticsEventType;
(function (FoundationAnalyticsEventType) {
    FoundationAnalyticsEventType["controlClicked"] = "controlClicked";
    FoundationAnalyticsEventType["routeChanged"] = "routeChanged";
})(FoundationAnalyticsEventType || (FoundationAnalyticsEventType = {}));
/**
 * The default implementation for the FoundationAnalytics interface.
 * @public
 */
export class DefaultFoundationAnalytics {
    /**
     * TODO: Remove the static config.
     * We could register a config with the container at startup and have it injected here or remove the constructor and
     * define a method call.
     */
    constructor(config) {
        this.analytics = Analytics(config);
    }
    trackEvent(eventName, payload) {
        logger.debug(`FoundationAnalytics.trackEvent ${eventName} : ${JSON.stringify(payload)}`);
        this.analytics.track(eventName, payload);
    }
}
/**
 * The DI token for the FouundationAnalytics interface.
 * @internal
 */
export const FoundationAnalytics = DI.createInterface((x) => x.singleton(DefaultFoundationAnalytics));
/**
 * Manual usage example:
 *
 * FoundationAnalyticsService.trackEvent(FoundationAnalyticsEventType.routeChanged, {
 *     path: "settings",
 * });
 *
 * See login mf.
 */
